import React, { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "./Header";
import { MESFMainContainer } from "./MainContainer";

const Navigation = ({
	showAreaSelector = false,
	showTrendingsIcon = true,
	navbarTitle = "MESF",
}: {
	showAreaSelector?: boolean;
	showTrendingsIcon?: boolean;
	navbarTitle?: string;
}) => {
	const [params, setParams] = useSearchParams();
	const mounted = useRef(true);

	useEffect(() => {
		if (params.has("redirectTo")) {
			setTimeout(() => {
				if (mounted.current) {
					window.location.href = decodeURIComponent(
						params.get("redirectTo")!,
					);
				}
			}, 100);
		}

		return () => {
			mounted.current = false;
		};
	}, [params.toString()]);

	return (
		<div className="wrapper">
			{/*<!-- top navbar-->*/}
			<Header
				showAreaSelector={showAreaSelector}
				navbarTitle={navbarTitle}
				showTrendingsIcon={showTrendingsIcon}
			/>
			{/*<!-- sidebar-->*/}
			{/* <SideBar/>      */}

			<MESFMainContainer />
			{/*<!-- Page footer-->*/}
			{/* <Footer/>                      */}
		</div>
	);
};
export default Navigation;
